import React, { FC, useMemo } from 'react'
import Select from 'components/SA/Select'
import styles from './SelectHitsPerPage.module.scss'
import classNames from 'classnames'

const options = [25, 50, 100]

type SelectHitsPerPageProps = {
  hitsPerPage: number
  handleChangeHitsPerPage: (optionObject) => void
  customStyles?: string
}

const SelectHitsPerPage: FC<SelectHitsPerPageProps> = ({
  hitsPerPage,
  handleChangeHitsPerPage,
  customStyles = '',
}) => {
  const numberOfHitsArray = useMemo(() => {
    return options.map((numberResults) => ({
      label: `${numberResults} Results Per Page`,
      value: `${numberResults}`,
    }))
  }, [])

  const selectValue = numberOfHitsArray.find(({ value }) => value === `${hitsPerPage}`)

  return (
    <div className={classNames(styles.selectContainer, { [customStyles]: customStyles !== '' })}>
      <Select
        value={selectValue}
        onChange={handleChangeHitsPerPage}
        aria-label='Hits Per Page'
        dataSection='hits-per-page'
        options={numberOfHitsArray}
      />
    </div>
  )
}

export default SelectHitsPerPage
